import React, { useState } from "react";
import OTPbox from "sushiweb/InputTypes/OTPbox";
import AnimatedDialog from "../../../Common/AnimatedDialog";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SuccessMessages from "../../../../constants/SucessMessages.json";
import * as AssetsIssuanceActions from "../../../../store/actions/AssetsIssuance";
import * as UserActions from "../../../../store/actions/User";

const OTPVerificationModal = (props) => {
  const {
    next,
    handleReject,
    setStatus,
    driverDetails,
    partnerDetails,
    verifyOtp,
    sendOtp,
    issuingAssets,
    transaction_id,
  } = props;
  const [otp, setOtp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  //otp handling
  const handleAccept = (otp) => {
    setOtp(otp);
  };

  const handleChange = (e) => {};

  const handleVerifyOtp = () => {
    if (otp) {
      setLoading(true);
      const payload = {
        assets_data: issuingAssets,
        driver_id: driverDetails.driver_id,
        onboarding_center_id: partnerDetails.onboarding_center_id,
        transaction_id: transaction_id,
        otp: otp,
      };
      verifyOtp(payload).then((res) => {
        if (res) {
          next();
        } else {
          setError("The OTP you have entered is either incorrect or expired");
        }
        setLoading(false);
      });
    }
  };

  const handleResendOtp = () => {
    setLoading(true);
    const payload = {
      assets_data: issuingAssets,
      phone_no: driverDetails.phone_number,
    };
    sendOtp(payload).then((res) => {
      if (res) {
        setStatus({
          type: "success",
          message: SuccessMessages.OTP_SEND_SUCCESS,
        });
      }
      setLoading(false);
    });
  };

  return (
    <AnimatedDialog
      header
      heading="OTP Verification"
      subHeading="You have requested assets issuance"
      isVisible
      acceptLabel="Verify OTP"
      rejectLabel="Cancel"
      handleAccept={handleVerifyOtp}
      handleReject={handleReject}
      permission
    >
      <h3 className="text-gray">Enter the OTP received to proceed.</h3>
      <OTPbox
        id={"otpInput"}
        onChange={handleChange}
        length={6}
        fnInputFill={handleAccept}
        inputType="number"
        loading={loading}
      />
      {error && (
        <>
          <div className="error-state otp-error">{"*" + error}</div>
          <div onClick={handleResendOtp} className="link-state">
            Resend OTP
          </div>
        </>
      )}
    </AnimatedDialog>
  );
};

function mapStateToProps(state) {
  const { AssetsIssuance } = state;
  return {
    driverDetails: AssetsIssuance.driverDetails,
    partnerDetails: AssetsIssuance.partnerDetails,
    issuingAssets: AssetsIssuance.issuingAssets.assets_data,
    transaction_id: AssetsIssuance.issuingAssets.transaction_id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verifyOtp: bindActionCreators(AssetsIssuanceActions.verifyOtp, dispatch),
    sendOtp: bindActionCreators(AssetsIssuanceActions.sendOtp, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OTPVerificationModal);
